import * as TabsPrimitive from '@radix-ui/react-tabs';

export const Tabs = TabsPrimitive.Root;

export function TabsList({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  return (
    <TabsPrimitive.List
      className={`flex border-b border-gray-200 gap-1 mb-3 ${className}`}
    >
      {children}
    </TabsPrimitive.List>
  );
}

export function TabsTrigger({
  value,
  children,
  className = '',
}: {
  value: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <TabsPrimitive.Trigger
      value={value}
      className={`px-4 py-2 text-sm font-medium text-gray-600 border-b-2 border-transparent hover:text-primary hover:border-primary/40 data-[state=active]:text-primary data-[state=active]:border-primary transition-colors cursor-pointer ${className}`}
    >
      {children}
    </TabsPrimitive.Trigger>
  );
}

export const TabsContent = TabsPrimitive.Content;
